import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SmsButtonMenuComponent } from './sms-button-menu.component';


@NgModule({
  declarations: [
    SmsButtonMenuComponent
  ],
  imports: [
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    SmsButtonMenuComponent
  ]
})
export class SmsButtonMenuModule { }
